import { MenuItem } from '@mui/material';
import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ContainerTypeQueryKeys, fetchContainerTypes } from 'services/clients/containerType';
import { Selector } from 'components/Selectors';

interface Props {
  value: string;
  onChange: (value: string) => void;
  size?: 'small' | 'medium';
  containersToShow?: string[];
  label?: string;
}

export const ContainerTypeSelector: React.FC<Props> = (props) => {
  const { value, onChange, containersToShow } = props;
  const containerTypes = useQuery(
    [ContainerTypeQueryKeys.ContainerTypes],
    ({ signal }) => fetchContainerTypes({ signal }),
    {
      onError: (e) => {
        // eslint-disable-next-line no-console
        console.error(e);
      },
    }
  );

  const items = React.useMemo(() => {
    if (!containerTypes.data) {
      return [];
    }

    let data = [...containerTypes.data].sort((a, b) => a.order - b.order);

    if (containersToShow) {
      data = data.filter((ct) => containersToShow.includes(ct.key));
    }

    return data.map((containerType) => {
      return (
        <MenuItem key={containerType.key} value={containerType.key}>
          {containerType.name}
        </MenuItem>
      );
    });
  }, [containerTypes, containersToShow]);

  return (
    <Selector
      id="container-type-selector"
      label={props.label || 'Container Type'}
      value={containerTypes.data ? value || '' : ''}
      onChange={onChange}
      disabled={!containerTypes.isSuccess}
      loading={containerTypes.isLoading}
      placeholder="Select a container type"
      renderValue={(v) => containerTypes.data?.find((ct) => ct.key === v)?.name}
      size={props.size}
    >
      {items}
    </Selector>
  );
};
ContainerTypeSelector.displayName = 'Selector.ContainerType';
